// Withdrawn / renamed product slugs — redirect map for previously-live URLs
// that may already be indexed in Search Console. When a visitor lands on any
// key here we perform a client-side `<Navigate replace>` to the target
// route rather than showing a 404.
//
// NOTE: For the *-vial → base slug rename below (Part 2 of the URL SEO
// migration, 2026-08-22), the real HTTP 301 is served at the edge by a
// Cloudflare Bulk Redirect rule on pepdirect.co — this client-side map is
// the graceful fallback for direct hits in preview or if the edge rule
// hasn't propagated yet.
//
// Kept as a single flat object rather than a route-per-slug so it's
// trivial to add/remove entries when SKUs come back or go dark.
export const PRODUCT_REDIRECTS = {
  // Pen Kits withdrawn 2026-08-17 — six SKUs kept live (Retatrutide, GLOW,
  // KLOW, HULK, Wolverine, NAD+). Ones with a Raw Vial equivalent map to
  // that PDP; the rest fall back to the Raw Vials category page since
  // that's the closest remaining format.
  "bpc-157-pen": "/raw-vials",
  "tb-500-pen": "/raw-vials",
  "cjc-1295-pen": "/raw-vials",
  "ghk-cu-pen": "/product/ghk-cu",
  "mots-c-pen": "/product/mots-c",
  "pt-141-pen": "/raw-vials",
  // Vial Kits withdrawn 2026-08-18 — the entire format was folded into
  // Raw Vials. Each redirect targets the renamed Raw Vial slug (Part 2).
  "retatrutide-vial-kit": "/product/retatrutide",
  "nad-plus-vial-kit": "/product/nad-plus",
  "mots-c-vial-kit": "/product/mots-c",
  "ghk-cu-vial-kit": "/product/ghk-cu",
  "melanotan-ii-vial-kit": "/product/melanotan-2",
  "glow-vial-kit": "/product/glow",
  "klow-vial-kit": "/product/klow",
  "hulk-vial-kit": "/product/hulk",
  "wolverine-vial-kit": "/product/wolverine",
  // Raw Vial slug rename 2026-08-22 (Part 2). Old slug ended in `-vial`,
  // new slug drops it. `melanotan-i` / `melanotan-ii` also renumbered
  // to `melanotan-1` / `melanotan-2`. Product IDs, prices, stock and
  // content are unchanged — only the public URL slug moved.
  // Retatrutide / Tirzepatide / Semaglutide intentionally NOT migrated.
  "aod-9604-vial": "/product/aod-9604",
  "bpc-157-vial": "/product/bpc-157",
  "cagrilintide-vial": "/product/cagrilintide",
  "cjc-1295-dac-vial": "/product/cjc-1295-dac",
  "cjc-1295-no-dac-vial": "/product/cjc-1295-no-dac",
  "dsip-vial": "/product/dsip",
  "epithalon-vial": "/product/epithalon",
  "ghk-cu-vial": "/product/ghk-cu",
  "glow-vial": "/product/glow",
  "hulk-vial": "/product/hulk",
  "ipamorelin-vial": "/product/ipamorelin",
  "klow-vial": "/product/klow",
  "kpv-vial": "/product/kpv",
  "melanotan-i-vial": "/product/melanotan-1",
  "melanotan-ii-vial": "/product/melanotan-2",
  "mots-c-vial": "/product/mots-c",
  "nad-plus-vial": "/product/nad-plus",
  "pt-141-vial": "/product/pt-141",
  "selank-vial": "/product/selank",
  "semax-vial": "/product/semax",
  "tb-500-vial": "/product/tb-500",
  "wolverine-vial": "/product/wolverine",
  // Retatrutide slug rename 2026-08-22 (Part 3). Vial and Pen slugs
  // simplified after the compliance review. Product IDs, prices, stock,
  // variants and content are all unchanged — only the public URL moved.
  "retatrutide-vial": "/product/retatrutide",
  "retatrutide-40mg-pen": "/product/retatrutide-pen",
  // Tirzepatide + Semaglutide withdrawn 2026-02 with NO one-to-one canonical
  // successor. Client-side navigation to /peptides or a category filter
  // would create soft-404 behaviour (200 OK on an unrelated page), which
  // hurts SEO more than a genuine Not Found. Direct hits fall through to
  // the standard NotFoundPage: visible copy, `<meta name="robots" content="noindex, follow">`,
  // no canonical. Backend already returns 404 on /api/products/tirzepatide-vial
  // and /api/products/semaglutide-vial so ProductPage renders NotFoundPage.
};

export function getProductRedirect(slug) {
  if (!slug) return null;
  return PRODUCT_REDIRECTS[slug] || null;
}
